module.exports = __webpack_public_path__ + "img/ANTENNA FLOWER RED.64e639c.svg";